import(/* webpackMode: "eager", webpackExports: ["Skeleton"] */ "/app/apps/nivex-frontend/src/components/ui/skeleton.tsx");
